
export const Search = (props : any) => {
    return (
        <svg width={props.width || "16"} height={props.height || "16"} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="m13.072 11.812-2.317-2.318c-.012-.012-.027-.02-.04-.032a4.385 4.385 0 1 0-1.253 1.253c.011.013.02.028.032.04l2.318 2.317a.891.891 0 0 0 1.26-1.26zm-6.02-1.895a2.865 2.865 0 1 1 0-5.73 2.865 2.865 0 0 1 0 5.73z" fill={props.color || "#293359"} fillRule="evenodd" opacity=".5"/>
        </svg>
    );
}
